"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = require("qs");
const queryBuild = (query, options = {}) => {
    const optionsDefault = {
        arrayFormat: 'indices',
    };
    const optionsNew = Object.assign(Object.assign({}, optionsDefault), options);
    return (0, qs_1.stringify)(query, optionsNew);
};
exports.default = queryBuild;
